import { Component, Input, OnInit } from '@angular/core';

@Component({
	selector: 'app-custom-progress-bar',
	styleUrls: ['./custom-progress-bar.component.css'],
	templateUrl: './custom-progress-bar.component.html'
})
export class CustomProgressBarComponent implements OnInit {
	@Input() progressBarColorPalette;
	@Input() progressBarConfiguration;

	constructor() {}

	ngOnInit(): void {}
}
